<div [ngClass]="pagePalette.background100" class="tw-px-[18px] tw-pt-7 tw-pb-3">
  @if(!regimen?.orderPlaced) {
    <h2 class="tw-font-lexend tw-font-extrabold tw-text-400 tw-text-gray-800" i18n="@@chooseYourRightPlan"> Choose your right plan </h2>
  } @else {
    <h2 class="tw-font-lexend tw-font-extrabold tw-text-400 tw-text-gray-800" i18n="@@yourPlan"> Your plan </h2>
  }
  <div class="tw-mt-[17px] tw-mb-[14px]">
    @if(!regimen?.orderPlaced) {
      <div class="tw-flex tw-items-center tw-justify-between tw-bg-white tw-rounded-lg"
      (click)="emitChangeRegimenKitInfo(appConfig.Shared.Regimen.variant.advance)"
      [ngClass]="(regimen.variantId === appConfig.Shared.Regimen.VariantId.variant_1499 || !regimen.variantId) ? [selectedVariantOutlineClasses, corePalette.border600] : ''">
      <div class="tw-flex tw-items-center tw-gap-3 tw-py-4 tw-pl-4">
        @if(is1499VariantSelected) {
          <cs-icon class="tw-w-6 tw-h-6" [iconName]="'rebranding/v1/teal_checkbox'"></cs-icon>
        } @else {
          <cs-icon class="tw-w-6 tw-h-6" [iconName]="'rebranding/v1/black_checkbox'"></cs-icon>
        }
        <div>
          <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800 tw-leading-[19px]" i18n="@@coreTreatmentPlan">Core Treatment Plan</p>
          <span class="tw-font-lexend tw-font-normal tw-text-200 tw-text-gray-400 tw-line-through">₹{{coreVariant.fixedPriceMRP}}</span><span class="tw-font-lexend tw-font-normal tw-text-200 tw-text-gray-800"> ₹{{coreVariant.fixedPrice}}</span>
        </div>
      </div>
      <div class="tw-w-[94px] tw-self-start tw-mr-[5px]">
        <img [src]="coreVariantImage" />
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-bg-white tw-rounded-lg tw-shadow-z4 tw-mt-[9px]"
      (click)="emitChangeRegimenKitInfo(appConfig.Shared.Regimen.variant.pro)"
      [ngClass]="regimen.variantId === appConfig.Shared.Regimen.VariantId.variant_1999 ? [selectedVariantOutlineClasses, advancedPalette.border600] : ''">
      <div class="tw-flex tw-items-center tw-gap-3 tw-py-4 tw-pl-4">
        @if(is1999VariantSelected) {
          <cs-icon class="tw-w-6 tw-h-6" [iconName]="'rebranding/v1/teal_checkbox'"></cs-icon>
        } @else {
          <cs-icon class="tw-w-6 tw-h-6" [iconName]="'rebranding/v1/black_checkbox'"></cs-icon>
        }
      <div>
          <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800 tw-leading-[19px]" i18n="@@advancedPlan">Advanced Plan</p>
          <span class="tw-font-lexend tw-font-normal tw-text-200 tw-text-gray-400 tw-line-through">₹{{advancedVariant.fixedPriceMRP}}</span><span class="tw-font-lexend tw-font-normal tw-text-200 tw-text-gray-800"> ₹{{advancedVariant.fixedPrice}}</span>
        </div>
      </div>
      <div class="tw-w-[94px] tw-self-start tw-mr-[5px]">
        <img [src]="advancedVariantImage" />
      </div>
    </div>
    } @else {
      <div class="tw-flex tw-items-center tw-justify-between tw-bg-white tw-rounded-lg tw-shadow-z4 tw-mt-[9px] tw-outline tw-outline-[1.5px]" [ngClass]="pagePalette.border600">
        <div class="tw-flex tw-items-center tw-gap-3 tw-py-4 tw-pl-4">
          <div>
            @if(is1499VariantSelected) {
              <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800 tw-leading-[19px]" i18n="@@coreTreatmentPlan">Core Treatment Plan</p>
            } @else if (is1999VariantSelected) {
              <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800 tw-leading-[19px]" i18n="@@advancedPlan">Advanced Plan</p>
            } @else {
              <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800 tw-leading-[19px]" i18n="@@coreTreatmentPlan">Core Treatment Plan</p>
            }
            <span class="tw-font-lexend tw-font-normal tw-text-200 tw-text-gray-400 tw-line-through">₹{{regimen.fixedPriceMRP}}</span><span class="tw-font-lexend tw-font-normal tw-text-200 tw-text-gray-800"> ₹{{regimen.fixedPrice}}</span>
          </div>
        </div>
        <div class="tw-w-[94px] tw-self-start tw-mr-[5px]">
          <img [src]="regimen?.regimenCoverImage" />
        </div>
      </div>
    }

  </div>
  <!-- Your plan includes section -->
  <div class="tw-pl-1 tw-mt-[14px] tw-mb-4">
    <p class="tw-font-lexend tw-font-normal tw-text-100 tw-leading-5 tw-text-gray-800"> <span i18n="@@yourPlanIncludes" class="tw-uppercase">Your Plan includes</span>: </p>
    <div class="tw-flex tw-items-center tw-gap-[9px]">
      <cs-icon class="tw-w-4 tw-h-4" [iconName]="'check'"></cs-icon>
      <p class="tw-text-200 tw-leading-[24px]">
        <span class="tw-text-gray-900 tw-font-normal tw-font-lexend"> {{getProductsCount}} <span i18n="@@products">Products</span> </span>
        <span class="tw-italic tw-font-body tw-font-semibold" [ngClass]="pagePalette.text600" (click)="viewProducts()"> (<span i18n="@@viewProducts">View Products</span>) </span>
      </p>
    </div>
    <div class="tw-flex tw-items-center tw-gap-[9px]">
      <cs-icon class="tw-w-4 tw-h-4" [iconName]="'check'"></cs-icon>
      <span class="tw-text-200 tw-text-gray-800 tw-font-normal tw-capitalize tw-leading-[24px] tw-font-lexend" i18n="@@monthlyDoctorCheckup"> Monthly Doctor Checkup </span>
    </div>
    <div class="tw-flex tw-items-center tw-gap-[9px]">
      <cs-icon class="tw-w-4 tw-h-4" [iconName]="'check'"></cs-icon>
      <span class="tw-text-200 tw-text-gray-800 tw-font-normal tw-capitalize tw-leading-[24px] tw-font-lexend" i18n="@@dietPlan"> Diet Plan </span>
    </div>
    <div class="tw-flex tw-items-center tw-gap-[9px]">
      <cs-icon class="tw-w-4 tw-h-4" [iconName]="'check'"></cs-icon>
      <p class="tw-font-normal tw-capitalize tw-leading-[24px]">
        <span class="tw-text-200 tw-text-gray-800 tw-font-lexend" i18n="@@dedicatedDoctor">Dedicated Doctor </span> -
        <span class="tw-text-100 tw-text-gray-500 tw-font-lexend" i18n="@@forAnytimeSupport">For anytime support</span> </p>
    </div>
    @if (is1999VariantSelected) {
      <div class="tw-flex tw-items-center tw-gap-[9px]">
        <cs-icon class="tw-w-4 tw-h-4" [iconName]="'check'"></cs-icon>
        <span class="tw-text-200 tw-text-gray-800 tw-font-normal tw-capitalize tw-leading-[24px] tw-font-lexend" i18n="@@consultationWithNutritionist">Consultation with Nutritionist</span>
      </div>
    }
  </div>
  <div class="tw-pl-1">
    <hr class="tw-border-gray-900 tw-opacity-10">
    @if (is1499VariantSelected) {
      <p class="tw-font-lexend tw-font-normal tw-text-100 tw-leading-5 tw-text-gray-500 tw-italic tw-mt-1.5" i18n="@@improvementStartsIn4to6"> Improvement starts in <span class="tw-font-bold">4-6 weeks</span> </p>
    } @else if (is1999VariantSelected) {
      <p class="tw-font-lexend tw-font-normal tw-text-100 tw-leading-5 tw-text-gray-500 tw-italic tw-mt-1.5" i18n="@@improvementStartsIn3to4"> Improvement starts in <span class="tw-font-bold">3-4 weeks</span> </p>
    }
  </div>
</div>
